import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import exchangeService from '../../services/exchangeService';
import ExchangeNav from './ExchangeNav';
import { FaSpinner, FaCommentDots } from 'react-icons/fa';
import '../../ChatRoomList.css';

// 매칭이 성사된 상대들의 목록이다. 여기서 하나를 누르면 실제 채팅방(ChatRoom)으로 들어간다.
// 카카오톡처럼 마지막 메시지 미리보기 + 안 읽은 개수 배지를 보여주고, 새 메시지가 오면
// 목록에도 반영되도록 5초마다 조용히 다시 불러온다(채팅방 안의 3초 폴링보다는 느슨하게).
const ChatRoomList = () => {
  const [chatRooms, setChatRooms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const pollIntervalRef = useRef(null);

  useEffect(() => {
    fetchChatRooms(true);
    pollIntervalRef.current = setInterval(() => fetchChatRooms(false), 5000);
    return () => clearInterval(pollIntervalRef.current);
  }, []);

  const fetchChatRooms = async (isInitial) => {
    try {
      if (isInitial) setLoading(true);
      const response = await exchangeService.getChatRooms();
      setChatRooms(response.data || []);
    } catch (err) {
      console.error('채팅방 목록 조회 오류:', err);
      if (isInitial) setErrorMessage('채팅방 목록을 불러오는 중 오류가 발생했다.');
    } finally {
      if (isInitial) setLoading(false);
    }
  };

  // 카카오톡처럼: 오늘이면 시간만, 아니면 날짜만 짧게 보여준다.
  const formatPreviewTime = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const now = new Date();
    const isToday = date.toDateString() === now.toDateString();
    if (isToday) {
      return date.toLocaleTimeString('ko-KR', { hour: '2-digit', minute: '2-digit' });
    }
    return date.toLocaleDateString('ko-KR', { month: 'numeric', day: 'numeric' });
  };

  if (loading) {
    return (
      <>
        <ExchangeNav />
        <div className="exchange-loading">
          <FaSpinner className="exchange-spinner" />
          <p>불러오는 중이다...</p>
        </div>
      </>
    );
  }

  return (
    <>
      <ExchangeNav />
      <div className="chat-room-list-container">
        <h1 className="chat-room-list-title">채팅함</h1>

        {errorMessage && <div className="exchange-error">{errorMessage}</div>}

        {chatRooms.length === 0 ? (
          <div className="exchange-empty-state">
            <p>아직 매칭된 상대가 없다. 매칭 요청을 받거나 보내서 매칭을 성사시켜달라.</p>
          </div>
        ) : (
          <div className="chat-room-list">
            {chatRooms.map((room) => (
              <Link key={room.id} to={`/exchange/chats/${room.id}`} className="chat-room-item">
                <div className="chat-room-avatar">
                  <FaCommentDots />
                </div>
                <div className="chat-room-info">
                  <div className="chat-room-info-top">
                    <span className="chat-room-nickname">{room.partnerNickname}</span>
                    <span className="chat-room-preview-time">
                      {formatPreviewTime(room.lastMessageAt || room.matchedAt)}
                    </span>
                  </div>
                  <div className="chat-room-info-bottom">
                    <span className="chat-room-last-message">
                      {room.lastMessage
                        ? room.lastMessage
                        : `${room.matchedAt ? new Date(room.matchedAt).toLocaleDateString('ko-KR') : ''} 매칭됨 · 대화를 시작해보라`}
                    </span>
                    {room.unreadCount > 0 && (
                      <span className="chat-room-unread-badge">
                        {room.unreadCount > 99 ? '99+' : room.unreadCount}
                      </span>
                    )}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default ChatRoomList;
